import React, {useState} from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import {labels} from '../../../../../../util/utils';
import {entities} from '../../../../../../util/uiconstants';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Checkbox from '../../../../BaseComponentWrappers/MotifCheckbox';
import FormField from '../../../../BaseComponentWrappers/MotifFormField';

const configuration = {
	[entities.ItSoApplication]: {
		selector: (state, bodyId) => {
			return (
				state.bodiesSpecial.itApplications?.byId &&
				Object.values(state.bodiesSpecial.itApplications?.byId).filter(
					(itApp) => state.bodiesSpecial.metadata[bodyId]?.allIds?.includes(itApp.id) && !itApp.isServiceOrganization
				)
			);
		},
		countCollectionKey: 'itProcesses',
		unassociatedLabel: labels.showOnlyUnrelated
	},
	[entities.ItProcess]: {
		selector: (state, bodyId) => {
			return (
				state.bodiesSpecial.itProcesses?.byId &&
				Object.values(state.bodiesSpecial.itProcesses?.byId).filter((itProcess) =>
					state.bodiesSpecial.metadata[bodyId]?.allIds?.includes(itProcess.id)
				)
			);
		},
		countCollectionKey: 'itApplications',
		unassociatedLabel: labels.showOnlyUnrelated
	}
};

export default function UnassociatedEntityCount({bodyId, entityId, onFilterChange, filterIds}) {
	const [filterIsActive, setFilterIsActive] = useState(false);
	const entityObjects = useSelector((state) => configuration[entityId].selector(state, bodyId), shallowEqual);
	let count = 0;

	const countfunc = () => {
		entityObjects?.forEach((entity) => {
			if (
				!entity[configuration[entityId].countCollectionKey] ||
				entity[configuration[entityId].countCollectionKey].length === 0
			) {
				count++;
			}
		});
		return count;
	};
	return (
		<>
			{(countfunc() > 0 || (filterIsActive && filterIds?.length > 0)) && (
				<Wrapper className="UnassociatedCheckboxWrapper">
					<FormField
						children={
							<Checkbox
								id={entityId ? entityId.toString() : entityId}
								value="checkbox"
								name="checkbox"
								checked={filterIsActive}
								onChange={() => {
									setFilterIsActive(!filterIsActive);
									onFilterChange('filterUnassociated', !filterIsActive);
								}}
								label={configuration[entityId].unassociatedLabel.replace('{0}', count)}
							/>
						}
					/>
				</Wrapper>
			)}
		</>
	);
}

const Wrapper = styled.section`
	// text-decoration: ${(props) => (props.filterIsActive ? 'underline' : 'none')};
	// font-style: ${(props) => (props.filterIsActive ? 'italic' : 'normal')};
	// :hover {
	// 	cursor: pointer;
	// 	text-decoration: underline;
	// }
	display: flex;
	.motif-form-field {
		margin-bottom: 0 !important;
		height: inherit !important;
		.motif-checkbox-label-wrap {
			align-items: center;
			margin: 0;
			.motif-checkbox-label {
				width: 95%;
			}
		}
	}
`;

UnassociatedEntityCount.propTypes = {
	entityId: PropTypes.number.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	bodyId: PropTypes.oneOf([PropTypes.number, PropTypes.string]).isRequired
};
